<script setup lang="ts">
import { RouterView } from 'vue-router';
import { storeToRefs } from 'pinia';
import { useContextMenuStore } from '@/stores/useContextMenuStore';
import { useAuth0 } from '@auth0/auth0-vue';

import ContextMenu from '@/common/ContextMenu.vue';

const { showContextMenu, menuX, menuY, linkUrl } = storeToRefs(useContextMenuStore());
const { onCloseContextMenu } = useContextMenuStore();
const { isLoading } = useAuth0();
</script>

<template>
  <SsToast :duration="5000" />
  <ContextMenu
    v-if="showContextMenu"
    :menu-x="menuX"
    :menu-y="menuY"
    :link="linkUrl"
    @close="onCloseContextMenu()"
  />
  <div v-if="isLoading">
    <LivPageLoader v-model="isLoading" />
  </div>
  <RouterView v-else />
</template>
